import { cva } from '../../../styled-system/css'

export const navbarItem = cva({
    base: {
        display: 'inline-block',
        backgroundColor: 'transparent', // reset button
        borderInline: 'none!', // reset button
        borderY: '[3px solid transparent]',
        paddingX: '2',
        paddingY: '[3px]',
        color: 'neutral.900!',
        textTransform: 'uppercase',
        textDecoration: 'none',
        whiteSpace: 'nowrap',
        _hover: {
            color: 'neutral.700',
            borderBottomColor: 'primary',
        },
        _focus: {
            boxShadow: '[0 0 0 0.1rem var(--shadow-color)]',
            boxShadowColor: `[green/40]`,
            borderY: 'none',
            outline: 'none',
        },
    },
})
